import { Text } from '@zillow/constellation-10';

export default function Bullet(): JSX.Element {
  return (
    <Text textStyle="body-xs" aria-hidden="true" css={{ color: 'text.subtle', marginInline: 'tighter' }}>
      &bull;
    </Text>
  );
}
